import {
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  FileOutlined,
  FolderOpenFilled,
  PlusOutlined,
  QuestionCircleOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import FolderIcon from "@src/styles/icon/folder-icon.svg";
import {
  Button,
  Col,
  Descriptions,
  Empty,
  Input,
  Modal,
  Row,
  Select,
  Tree,
} from "antd";
import _ from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import TitlePage from "../../../component/Desktop/titlePage";
import FooterPage from "../../../component/footer/footerPage";
import SplitComponent from "../../../component/split-component/SplitComponent";
import {
  COMMON_CONSTANT,
  INPUT_TYPE,
  KEY,
  lang,
  MODE_SCREEN,
  STYLE,
} from "../../../constants/common.const";
import {
  formatString,
  handleCatchError,
  renderOption,
  showMessage,
} from "../../../constants/utils";
import classDdl from "../../../models/control/dropdownlist";
import classText from "../../../models/control/text";
import "./../EquipmentMaster/equipmentMaster.scss";
import SelectWithLabel from "../../../component/FormInput/SelectWithLabel";
import kbn from "../../../api/backend/kbn";
import { Apifacility } from "../../../api/backend/facilityManagement";
import { InstallLocationMasterApi } from "../../../api/backend/installLocationMaster";
import Loading from "../../../component/Desktop/loading/loading";
import { isEmptyData } from "../../../utils/helper";
import { useSelector } from "react-redux";
import rolesConst from "../../../routers/roles/roles.const";
const { DirectoryTree } = Tree;
const transformData = (data, parentKey = "", expandedKeys = []) => {
  return data.map((item, index) => {
    const eachKey =
      item.itemCode !== "" &&
      item.itemCode !== null &&
      item.itemCode !== undefined
        ? item.itemCode + "-" + item.id
        : item.facilityCode;
    const key = parentKey !== "" ? `${parentKey}-${eachKey}` : `${eachKey}`;
    // const key = item.id || item.typeKey
    // const type = !item.type ? ORDER_TREE.EQUIPMENT : Number(item.type);

    const isOpen = expandedKeys.includes(key);
    const hasChildren =
      Array.isArray(item.children) && item.children.length > 0;
    const order = item.type ? Number(item.type) : 0;
    const name = item.facilityName || item.itemName;
    return {
      title: (
        <span
          style={{
            marginLeft: 5,
          }}
        >
          {name}
        </span>
      ),
      name: name,
      key: key,
      code: item.itemCode || item.facilityCode,
      id: item.id || item.facilityCode,
      order,
      facilityName: item.facilityName || "",
      machineClassification: item.typeKey || "",
      position: item.displayOrder,
      facilityNumber: item.facilityNumber,
      processingArea: item.processingArea,
      icon: hasChildren ? (
        !isOpen ? (
          <img
            style={{ width: 20, height: 20 }}
            src={FolderIcon}
            alt=""
            className="icon__confirm"
          />
        ) : (
          <FolderOpenFilled style={{ color: "#0080cb", fontSize: 23 }} />
        )
      ) : (
        <FileOutlined style={{ fontSize: 16 }} />
      ),
      isLeaf: !hasChildren,
      children: hasChildren
        ? transformData(item.children, key, expandedKeys)
        : order != 4
        ? []
        : undefined,
    };
  });
};
const LocationInstallMaster = () => {
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingScreen, setLoadingScreen] = useState(false);
  const [maxSize, setMaxSize] = useState(window.innerWidth - 400);
  const { collapsed } = useSelector((state) => state.sideBar);
  const [editData, setEditData] = useState(null);
  const [disabledEdit, setDisabledEdit] = useState(false);
  const [data, setData] = useState([]);
  const treeData = transformData(data, "", expandedKeys);

  const ORDER_TREE = {
    FACILITY: 0,
    INSTALL_LOCATION: 1,
    DETAIL_LOCATION: 2,
  };
  const dataLocationOrigin = {
    title: new classText(""),
    code: new classText(""),
    position: new classText(""),
    order: 1,
    ancestors: [],
    facilityName: "",
    parentId: "",
    facilityCode: "",
    id: "",
    area: new classDdl(),
  };
  const [dataLocation, setDataLocation] = useState(dataLocationOrigin);
  const [isFillData, setIsFillData] = useState(false);
  const [listOptionArea, setListOptionArea] = useState([]);

  const [mode, setMode] = useState(MODE_SCREEN.VIEW);
  const [currentNode, setcurrentNode] = useState({});
  const [listParent, setListParent] = useState([]);
  const [filterTree, setFilterTree] = useState(new classDdl());
  
  const {roles} = useSelector(state => state.auth)
  const isLead  = roles === rolesConst.HEAD_OFFICE_ADMIN 

  // CHECK AREA
  const haveArea =
    currentNode &&
    !isNaN(currentNode.facilityNumber) &&
    Number(currentNode.facilityNumber) >= 50;

  // GET PARENT KEY
  function findParent(data, targetKey, path = []) {
    for (const item of data) {
      const currentPath = [...path, item];
      if (item.key === targetKey) {
        return path;
      }
      if (item.children) {
        const result = findParent(item.children, targetKey, currentPath);
        if (result) {
          return result;
        }
      }
    }
    return null;
  }

  // FIND ITEM BY KEY
  function findItemByKey(data, targetKey) {
    for (const item of data) {
      if (item.key === targetKey) {
        return item;
      }
      if (item.children) {
        const found = findItemByKey(item.children, targetKey);
        if (found) return found;
      }
    }
    return null;
  }

  const getDetailNodeById = async (id) => {
    try {
      setLoading(true);
      const res = await InstallLocationMasterApi.getInstallLocationById(id);
      const data = res.data;
      const newData = {
        title: data.installLocationName,
        code: data.installLocationCode,
        order: Number(data.type),
        position: data.displayOrder,
        ancestors: data.ancestors || [],
        facilityName: data.facilityName,
        parentId: data.parentId,
        facilityCode: data.facilityCode,
        id: data.id,
        area: data.processingArea,
        areaName: data.areaName,
      };
      const parentsNode = findParent(treeData, currentNode.key);
      setDataLocation({
        ...dataLocation,
        title: {
          ...dataLocation.title,
          value: newData.title,
          error: false,
          message: "",
        },
        code: {
          ...dataLocation.code,
          value: newData.code,
          error: false,
          message: "",
        },
        position: {
          ...dataLocation.position,
          value: newData.position,
          error: false,
          message: "",
        },
        order: newData.order,
        ancestors: newData.ancestors,
        facilityName: newData.facilityName,
        facilityCode: newData.facilityCode,
        parentId: newData.parentId,
        id: data.id,
        area: {
          ...dataLocation.area,
          value: newData.area,
          error: false,
          valueShow: newData.areaName,
        },
      });
      setcurrentNode({
        ...data,
        order: Number(data.type),
        name: data.installLocationName,
        code: data.installLocationCode,
        position: data.displayOrder,
        ancestors: data.ancestors || [],
        facilityCode: data.facilityCode,
        id: data.id,
        area: data.processingArea,
        areaName: data.areaName,
      });
      setListParent(parentsNode);
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoading(false);
    }
  };
  // Handle select
  const onSelect = async (keys, info) => {
    // HAndle SELECT
    setSelectedKeys(keys);
    setMode(MODE_SCREEN.VIEW);
    const currentNode = info.node;
    const id = currentNode.id;
    const type = currentNode.order;
    if (type == ORDER_TREE.FACILITY) {
      setcurrentNode({
        ...currentNode,
      });

      return;
    }
    getDetailNodeById(id);
  };
  // get Title
  const getTitleByOrder = (order) => {
    let finalOrder = order || dataLocation.order;
    if (mode === MODE_SCREEN.ADD && !order) {
      finalOrder = finalOrder + 1;
    }
    switch (finalOrder) {
      case ORDER_TREE.FACILITY: {
        return {
          code: lang.FACILITY_ID,
          title: lang.FACILITY_MASTER_NAME,
          label: lang.FACILITY,
        };
      }
      case ORDER_TREE.INSTALL_LOCATION: {
        return {
          code: lang.INSTALL_LOCATION_CODE,
          title: lang.INSTALL_LOCATION_NAME,
          label: lang.INSTALL_LOCATION,
        };
      }
      case ORDER_TREE.DETAIL_LOCATION: {
        return {
          code: lang.DETAIL_LOCATION_CODE,
          title: lang.DETAIL_LOCATION_NAME,
          label: lang.DETAIL_LOCATION,
        };
      }

      default: {
        return {
          code: lang.FACILITY_ID,
          title: lang.FACILITY_MASTER_NAME,
          label: lang.FACILITY,
        };
      }
    }
  };

  // GET LABEL BY MODE
  const getLabelByMode = () => {
    let order = currentNode.order;
    if (mode === MODE_SCREEN.ADD) {
      order++;
    }

    const mainLabel = getTitleByOrder(order).label;
    let subLabel = "";
    if (mode === MODE_SCREEN.VIEW) {
      subLabel = lang.VIEW;
    }
    if (mode === MODE_SCREEN.ADD) {
      subLabel = lang.ADD;
    }
    if (mode === MODE_SCREEN.EDIT) {
      subLabel = lang.EDIT;
    }
    return mainLabel + subLabel;
  };

  function isRegex(a) {
    return a instanceof RegExp;
  }

  // Change Input
  const changeData = (key, value, rule) => {
    if (rule && isRegex(rule)) {
      if (!rule.test(value)) {
        return;
      }
    }
    setIsFillData(true);
    setDataLocation({
      ...dataLocation,
      [key]: { ...dataLocation[key], value },
    });
  };

  // HANDLE EXPAND TREE
  const handleExpand = (expandedKeysValue, { node }) => {
    if (mode === MODE_SCREEN.ADD || mode === MODE_SCREEN.EDIT || loading) {
      return;
    }
    onSelect([node.key], { node });
    setExpandedKeys(expandedKeysValue);
  };
  function findNodeById(tree, targetId) {
    for (const node of tree) {
      if (node.id === targetId) {
        return node;
      }
      if (node.children) {
        const found = findNodeById(node.children, targetId);
        if (found) return found;
      }
    }
    return null;
  }

  // CLICK ADD _ EDIT
  const handleClickAddEdit = (m = "ADD") => {
    setMode(MODE_SCREEN[m]);
    if (m === "ADD") {
      const currentKey = currentNode.key;
      let node;
      let newCode = "01";
      if (currentNode) {
        node = findNodeById(treeData, currentNode.id);
        if (
          node &&
          node.children &&
          Array.isArray(node.children) &&
          node.children.length
        ) {
          const listCodeOfChilren = node.children.map((i) => Number(i.code));
          newCode = Number(Math.max(...listCodeOfChilren)) + 1;
          newCode = newCode < 10 ? "0" + newCode : newCode;
        }
      }
      setDataLocation({
        ...dataLocation,
        title: { ...dataLocation.title, value: "" },
        code: { ...dataLocation.code, value: newCode },
        position: {
          ...dataLocation.position,
          value: "",
        },
        area: {
          ...dataLocation.area,
          value: currentNode ? currentNode.processingArea : "",
        },
      });
    } else {
      setEditData(JSON.parse(JSON.stringify(dataLocation)));
      setDisabledEdit(true);
    }
  };
  // Popup common
  const showConfirmMessage = (
    msg,
    callbackOK,
    callbackCancel,
    typeInfo = false
  ) => {
    let ok, cancel;
    const callBackDefault = () => {
      Modal.destroyAll();
    };

    // Callback OK exist
    if (callbackOK) {
      ok = () => {
        callbackOK();
        callBackDefault();
      };
    }
    // Callback Cancel exist
    if (callbackCancel) {
      cancel = () => {
        callbackCancel();
        callBackDefault();
      };
    }

    Modal.confirm({
      centered: true,
      icon: <QuestionCircleOutlined />,
      title: lang.CONFIRM,
      content: msg,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onCancel: cancel || callBackDefault,
      onOk: ok || callBackDefault,
    });
  };

  // Validate Data

  const validate = () => {
    let flagError = false;
    let currentCodeObj = dataLocation.code;
    let currentTitleObj = dataLocation.title;
    let currentPositionObj = dataLocation.position;
    let currentArea = dataLocation.area;
    const title = currentTitleObj.value.trim();
    const code = String(currentCodeObj.value).trim();
    let position = currentPositionObj.value;

    // Check empty
    if (!title) {
      flagError = true;
      currentTitleObj.error = true;
    } else {
      currentTitleObj.error = false;
    }
    if (!code) {
      flagError = true;
      currentCodeObj.error = true;
    } else {
      currentCodeObj.error = false;
    }
    if (!position && mode === MODE_SCREEN.EDIT) {
      flagError = true;
      currentPositionObj.error = true;
    } else {
      currentPositionObj.error = false;
    }

    if (haveArea) {
      if (isEmptyData(currentArea.value)) {
        flagError = true;
        currentArea.error = true;
      } else {
        currentArea.error = false;
      }
    }

    setDataLocation({
      ...dataLocation,
      title: currentTitleObj,
      code: currentCodeObj,
      position: currentPositionObj,
      area: currentArea,
    });
    return !flagError;
  };
  async function saveData() {
    try {
      setLoadingScreen(true);
      const modeEdit = mode === MODE_SCREEN.EDIT;
      const isBigClass =
        currentNode && currentNode.order == ORDER_TREE.FACILITY;
      const parentId =
        isBigClass && mode === MODE_SCREEN.ADD
          ? 0
          : mode === MODE_SCREEN.EDIT
          ? dataLocation.parentId
          : dataLocation.id;

      const dataPost = {
        installLocationCode: dataLocation.code.value,
        installLocationName: dataLocation.title.value,
        parentId: parentId,
        facilityCode: isBigClass ? currentNode.id : dataLocation.facilityCode,
      };
      if (haveArea) {
        dataPost.processingArea = dataLocation.area.value;
      }
      if (modeEdit) {
        dataPost.id = currentNode.id;
      }
      modeEdit
        ? await InstallLocationMasterApi.updateInstallLocation(dataPost)
        : await InstallLocationMasterApi.createInstallLocation(dataPost);
      showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C003, async () => {
        getTreeData();
        setMode(MODE_SCREEN.VIEW);
        setIsFillData(false);
        if (currentNode && currentNode.order != 0) {
          await getDetailNodeById(currentNode ? currentNode.id : "");
        }
      });
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoadingScreen(false);
    }
  }
  // SAVE
  const handleSave = () => {
    if (!validate()) {
      return;
    }
    showConfirmMessage(
      mode === MODE_SCREEN.ADD
        ? COMMON_CONSTANT.BOM_C008
        : COMMON_CONSTANT.BOM_C009,
      saveData
    );
  };

  const onCancel = () => {
    setMode(MODE_SCREEN.VIEW);
    setDataLocation({
      ...dataLocation,
      title: {
        ...dataLocation.title,
        value: currentNode.name,
        error: false,
        message: "",
      },
      code: {
        ...dataLocation.code,
        value: currentNode.code,
        error: false,
        message: "",
      },
      position: {
        ...dataLocation.display,
        value: currentNode.position,
        error: false,
        message: "",
      },
      area: {
        ...dataLocation.area,
        value: currentNode.area,
        valueShow: currentNode.areaName,
        error: false,
        message: "",
      },
    });
    setIsFillData(false);
  };
  // CANCEL
  const handleCancel = () => {
    if (isFillData) {
      Modal.confirm({
        centered: true,
        icon: <QuestionCircleOutlined />,
        title: lang.CONFIRM,
        content: COMMON_CONSTANT.BOM_C018,
        okText: lang.OK,
        cancelText: lang.CANCEL,
        onOk: onCancel,
      });
    } else {
      onCancel();
    }
  };

  /// DELETE
  const showMessageDeleteConfirm = () => {
    // Action del
    const funcDel = async () => {
      try {
        await InstallLocationMasterApi.deleteInstallLocation(currentNode.id);
        showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C004);
        getTreeData();
        setcurrentNode({});
        setDataLocation(dataLocationOrigin);
      } catch (error) {
        handleCatchError(error);
      }
    };

    Modal.confirm({
      icon: <QuestionCircleOutlined />,
      title: lang.DELETE,
      content: COMMON_CONSTANT.BOM_C001,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onOk: funcDel,
      centered: true,
    });
  };

  const getvalue = (order, type = "name") => {
    if (!currentNode) return;
    if (currentNode.order == ORDER_TREE.FACILITY) {
      if (order == ORDER_TREE.FACILITY) {
        return currentNode.name;
      }
    }
    if (currentNode.order == order && mode === MODE_SCREEN.ADD) {
      return currentNode[type];
    }
    if (
      (currentNode.order == order && mode !== MODE_SCREEN.ADD) ||
      (Number(currentNode.order) + 1 == Number(order) &&
        mode === MODE_SCREEN.ADD)
    ) {
      const exactType = type === "name" ? "title" : type;
      return dataLocation[exactType] && dataLocation[exactType].value;
    }
    if (currentNode.order < order) {
      return "";
    }
    // render list parent
    const listParent = currentNode.ancestors || [];
    const subCode = currentNode.order - order;
    const node = listParent[listParent.length - subCode];
    const finalType =
      type === "name" ? "installLocationName" : "installLocationCode";
    return node ? node[finalType] : "";
  };

  const isInput = (order) => {
    if (!currentNode) return false;
    if (mode === MODE_SCREEN.VIEW) return false;
    if (mode === MODE_SCREEN.ADD) return order == currentNode.order + 1;
    if (mode === MODE_SCREEN.EDIT) return order == currentNode.order;
  };
  const listView = [
    {
      title: lang.FACILITY_MASTER_NAME,
      value: currentNode ? currentNode.facilityName : "",
      key: "title",
      span: 5,
      isInput: false,
    },
    {
      title: lang.INSTALL_LOCATION_NAME,
      value: getvalue(ORDER_TREE.INSTALL_LOCATION, "code"),
      key: "code",
      rule: /^(\d{1,4})?$/,
      error: dataLocation.code.error,
      messError: dataLocation.code.message,
      required: isInput(ORDER_TREE.INSTALL_LOCATION),
      isInput: isInput(ORDER_TREE.INSTALL_LOCATION),
      disabled: mode === MODE_SCREEN.EDIT,
      span: 1,
      order: ORDER_TREE.INSTALL_LOCATION,
    },
    {
      title: lang.INSTALL_LOCATION_NAME,
      value: getvalue(ORDER_TREE.INSTALL_LOCATION, "name"),
      key: "title",
      rule: /^.{0,255}$/,
      error: dataLocation.title.error,
      messError: dataLocation.title.message,
      required: isInput(ORDER_TREE.INSTALL_LOCATION),
      isInput: isInput(ORDER_TREE.INSTALL_LOCATION),
      hideTitle: true,
      span: 4,
    },
    {
      title: lang.DETAIL_LOCATION_NAME,
      value: getvalue(ORDER_TREE.DETAIL_LOCATION, "code"),
      key: "code",
      rule: /^(\d{1,4})?$/,
      error: dataLocation.code.error,
      messError: dataLocation.code.message,
      required: isInput(ORDER_TREE.DETAIL_LOCATION),
      isInput: isInput(ORDER_TREE.DETAIL_LOCATION),
      disabled: mode === MODE_SCREEN.EDIT,
      span: 1,
      order: ORDER_TREE.DETAIL_LOCATION,
    },
    {
      title: lang.DETAIL_LOCATION_NAME,
      value: getvalue(ORDER_TREE.DETAIL_LOCATION, "name"),
      key: "title",
      rule: /^.{0,255}$/,
      error: dataLocation.title.error,
      messError: dataLocation.title.message,
      required: isInput(ORDER_TREE.DETAIL_LOCATION),
      isInput: isInput(ORDER_TREE.DETAIL_LOCATION),
      hideTitle: true,
      span: 4,
    },
    {
      title: lang.AREA_NAME_FACILITY,
      value: dataLocation.area.value,
      key: "area",
      rule: /^.{0,255}$/,
      error: dataLocation.area.error,
      messError: dataLocation.area.message,
      required:
        haveArea &&
        mode !== MODE_SCREEN.VIEW &&
        !(mode === MODE_SCREEN.ADD && currentNode && currentNode.order == 1) &&
        mode !== MODE_SCREEN.EDIT,
      type: INPUT_TYPE.SELECT,
      span: 5,
      isInput: mode !== MODE_SCREEN.VIEW,
      valueShow: dataLocation.area.valueShow,
      disabled:
        !haveArea ||
        mode === MODE_SCREEN.EDIT ||
        (mode === MODE_SCREEN.ADD && currentNode && currentNode.order == 1),
    },
    {
      title: lang.DISPLAY_ORDER,
      value: dataLocation.position.value,
      key: "position",
      rule: /^(\d{1,10})?$/,
      error: dataLocation.position.error,
      messError: dataLocation.position.message,
      isInput: mode !== MODE_SCREEN.VIEW,
      span: 5,
      disabled: true,
    },
  ];

  const currentOrder =
    currentNode && (currentNode.order || currentNode.order == 0)
      ? mode === MODE_SCREEN.ADD
        ? currentNode.order + 1
        : currentNode.order
      : 0;
  const hideValue =
    (!currentNode || currentNode.order == ORDER_TREE.FACILITY) &&
    mode === MODE_SCREEN.VIEW;

  // render
  const renderListView = (
    <Descriptions
      className="customEquipmentDes"
      size="small"
      column={5}
      bordered
    >
      {listView.map((cate, index) => (
        <React.Fragment key={cate.key}>
          <Descriptions.Item
            label={
              <>
                <span
                  style={{
                    color:
                      (currentOrder === cate.order && currentOrder != 0) ||
                      (cate.required && currentOrder != 0)
                        ? "#ff2255"
                        : "",
                  }}
                >
                  {cate.title}
                </span>
              </>
            }
            span={cate.span || 1}
            labelStyle={{
              width: "20%",
              fontWeight: "bold",
              display: cate.hideTitle && "none",
            }}
            contentStyle={{ padding: "8px 8px", width: 150 }}
          >
            {!cate.isInput ? (
              <span
              >
                {!hideValue ? cate.valueShow || cate.value : ""}
              </span>
            ) : (
              <div className="wrapErrorInput">
                {cate.type === INPUT_TYPE.SELECT ? (
                  <Select
                    className={(cate.error ? STYLE.BORDER_RED : "") + " w100 "}
                    onChange={(v) => changeData(cate.key, v, cate.rule)}
                    value={cate.value}
                    disabled={cate.disabled}
                  >
                    {renderOption(listOptionArea, false)}
                  </Select>
                ) : (
                  <Input
                    onBlur={(e) => {
                      const value = String(e.target.value).trim();
                      if (
                        cate.key === "code" &&
                        !isNaN(value) &&
                        Number(value) < 10 &&
                        Number(value) > 0 &&
                        !isEmptyData(value)
                      ) {
                        changeData(cate.key, "0" + Number(value), cate.rule);
                      }
                    }}
                    className={(cate.error ? STYLE.BORDER_RED : "") + " w100 "}
                    onChange={(e) =>
                      changeData(cate.key, e.target.value, cate.rule)
                    }
                    disabled={cate.disabled}
                    value={cate.value}
                  />
                )}

                {cate.error && (
                  <span style={{ color: "red", marginTop: 3 }}>
                    {cate.messError}
                  </span>
                )}
              </div>
            )}
          </Descriptions.Item>
        </React.Fragment>
      ))}
    </Descriptions>
  );

  // API - GET TREE
  const getTreeData = async () => {
    try {
      setLoading(true);
      const res = await InstallLocationMasterApi.getTree({
        facilityCode: filterTree.value,
      });
      setData(res.data);
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getTreeData();
  }, [filterTree.value]);

  // CHANGE FILTER TREE
  const handleChangeFilterTree = (value) => {
    setFilterTree({
      ...filterTree,
      value,
    });
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    Apifacility.searchNewFacility()
      .then((res) => {
        const listKbn = (res.data || []).map((i) => ({
          value: i.facilityName,
          key: i.facilityCode,
        }));
        setFilterTree(new classDdl("", listKbn));
      })
      .catch((error) => {
        handleCatchError(error);
      });
  }, []);

  // Option Area
  const getArea = async () => {
    try {
      const respArea = await kbn.getProcessArea();

      const dataArea = respArea.data.data;
      setListOptionArea(dataArea);
    } catch (error) {
      handleCatchError(error);
    }
  };
  useEffect(() => {
    getArea();
  }, []);
  useEffect(() => {
    const handleResize = () => {
      setMaxSize(collapsed ? window.innerWidth - 200 : window.innerWidth - 300);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setMaxSize(collapsed ? window.innerWidth - 200 : window.innerWidth - 300);
  }, [collapsed]);
  useEffect(() => {
    if (mode === MODE_SCREEN.EDIT && editData) {
      let isChange = false;
      ["title"].forEach((key) => {
        if (editData[key].value != dataLocation[key].value) {
          isChange = true;
        }
      });
      setDisabledEdit(!isChange);
    }
  }, [mode, editData, dataLocation.title]);
  return (
    <div className="des-content">
      <TitlePage name={lang.INSTALL_LOCATION_MASTER} />

      <SplitComponent
        minSize={40}
        maxSize={maxSize}
        split="vertical"
        defaultSize="33%"
      >
        {/* LEFT: Tree */}
        <div
          className="equipment-tree-detail"
          style={{ padding: 8, height: "100%", overflowY: "hidden" }}
        >
          <SelectWithLabel
            onChange={handleChangeFilterTree}
            value={filterTree.value}
            disabled={
              mode === MODE_SCREEN.ADD || mode === MODE_SCREEN.EDIT || loading
            }
            className="w100 mb10"
            options={filterTree.options}
            label={lang.FACILITY}
            allTitle={true}
            hasEmptyvalue={true}
          />
          <div
            className="mt10 pb10 pt10"
            style={{
              background: "#fff",
              minHeight: 150,
              maxHeight: "calc(100vh - 195px)",
              overflowY: "auto",
            }}
          >
            {treeData.length === 0 ? (
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            ) : (
              <DirectoryTree
                disabled={mode === MODE_SCREEN.ADD || mode === MODE_SCREEN.EDIT}
                onExpand={handleExpand}
                draggable
                onSelect={onSelect}
                treeData={treeData}
                selectedKeys={selectedKeys}
                expandedKeys={expandedKeys}
              />
            )}
          </div>
        </div>

        {/* RIGHT: View */}
        <div
          className="equipment-tree-detail"
          style={{ padding: 8, background: "#fff", height: "100%" }}
        >
          {renderListView}
        </div>
      </SplitComponent>
      <FooterPage>
        {mode !== MODE_SCREEN.ADD && mode !== MODE_SCREEN.EDIT ? (
          <Row justify="end">
            <Col>
              <Button
                disabled={
                  _.isEmpty(currentNode) ||
                  currentNode.order == ORDER_TREE.DETAIL_LOCATION
                }
                onClick={() => handleClickAddEdit("ADD")}
                className="buttonPC button--info wAuto ml10"
              >
                <PlusOutlined />
                {lang.ADD}
              </Button>
            </Col>
            <Col>
              <Button
                disabled={
                  _.isEmpty(currentNode) ||
                  currentNode.order == ORDER_TREE.FACILITY
                }
                onClick={() => handleClickAddEdit("EDIT")}
                className="buttonPC button--outline --todo-- wAuto ml15"
              >
                <EditOutlined />
                {lang.EDIT}
              </Button>
            </Col>
            <Col>
              <Button
                onClick={showMessageDeleteConfirm}
                disabled={
                  _.isEmpty(currentNode) ||
                  currentNode.order == ORDER_TREE.FACILITY || !isLead
                }
                className={`buttonPC ${
                  !_.isEmpty(currentNode) &&
                  currentNode.order !== ORDER_TREE.FACILITY && isLead
                    ? "button--error--outline"
                    : "button--outline --todo--"
                } ml15`}
              >
                <DeleteOutlined />
                {lang.DELETE}
              </Button>
            </Col>
          </Row>
        ) : (
          <>
            <Row justify="end">
              <Col>
                <Button
                  disabled={mode == MODE_SCREEN.EDIT && disabledEdit}
                  onClick={handleSave}
                  className="buttonPC button--info wAuto ml10"
                >
                  <SaveOutlined />
                  {lang.SAVE}
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={handleCancel}
                  className="buttonPC button--outline --todo-- wAuto ml15"
                >
                  <CloseCircleOutlined />
                  {lang.CANCEL}
                </Button>
              </Col>
            </Row>
          </>
        )}
      </FooterPage>
      <Loading show={loadingScreen} />
    </div>
  );
};

export default LocationInstallMaster;
